import { i18next } from '@frontend/i18n';
import { ContactStatus } from '../types';

export const getContactFilterStatusLabels = (
  prospectiveDataAvailable: boolean
): Record<ContactStatus, { label: string; available: boolean }> => {
  const contactsNamespace = 'contacts';
  return {
    [ContactStatus.ACTIVE]: { label: i18next.t('Active', { ns: contactsNamespace }), available: true },
    [ContactStatus.INACTIVE]: { label: i18next.t('Inactive', { ns: contactsNamespace }), available: true },
    [ContactStatus.PROSPECTIVE]: {
      label: i18next.t('Prospective', { ns: contactsNamespace }),
      available: prospectiveDataAvailable,
    },
  };
};
